<shared-toolbar title="Acciones Por Rol">
  <mat-form-field subscriptSizing="dynamic" appearance="outline">
    <mat-label>Buscar</mat-label>
    <input
      type="text"
      [(ngModel)]="fielInput"
      placeholder="Buscar usuarios..."
      (ngModelChange)="buscarRoles()"
      appearance="outline"
      #input
      matInput />
    <mat-icon matSuffix *ngIf="!input.value">search</mat-icon>
  </mat-form-field>
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content
    class="overflow-y-hidden overflow-x-scroll gap-4 sm:flex align-items-baseline sm:align-items-center">
    <!-- CARD ROLES -->
    <div class="w-full h-full">
      <div>
        <p mat-subheader class="text-2xl">Roles</p>
      </div>
      <div class="overflow-auto h-15rem">
        <mat-selection-list hideSingleSelectionIndicator="true" [multiple]="false">
          <mat-list-option *ngFor="let role of roles" (click)="setCurrentRole(role)" [value]="role" [matTooltip]="'Descripción: ' + role.description + ' Tipo: ' + role.type" matTooltipPosition="below">
            <a>{{ role.name }}</a>
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>

    <!-- CARD ACCIONES EN ROL -->
    <div class="w-full h-full">
      <div>
        <p mat-subheader class="text-2xl">Acciones</p>
      </div>
      <div>
        <div class="overflow-auto h-15rem">
          <p *ngIf="currentRole.roleid == -1">Seleccione un Rol</p>
          <mat-chip-set *ngIf="currentRole.roleid != -1">
            <mat-chip-option *ngFor="let val of showList" [selected]="val.state" [matTooltip]="'Descripción: ' + val.action.description + ' Tipo: ' + val.action.type" (click)="onChipClick(val)">
              {{ val.action.name }}
            </mat-chip-option>
          </mat-chip-set>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
